import React from 'react';
import {Routes, Route} from 'react-router-dom';
import WorkOrderDetail from './WorkOrderDetail';
import { Box } from '@mui/joy';
import { FeatureGate } from '../components/common/FeatureGate';
import { WorkOrderList as WorkOrderListTable } from '../components/subcontractors/WorkOrderList';

export default function WorkOrderList() {
  return (
    <FeatureGate
      requiredTiers={['pro', 'premium', 'enterprise']}
      featureName="Work Orders"
      featureDescription="Manage subcontractor work orders across all jobs in one place. Track scheduling, costs, and status from draft through completion."
      benefits={[
        'View work orders across every job and subcontractor',
        'Track scheduling and overdue assignments',
        'Monitor agreed costs and change orders',
        'Send, accept, start, and complete work orders',
        'Manage the full work order lifecycle',
      ]}
    >
      <Box sx={{ width: '100%' }}>
        <Routes><Route index element={<WorkOrderListTable/>}/><Route path=":id" element={<WorkOrderDetail/>}/></Routes>
      </Box>
    </FeatureGate>
  );
}
